import { useQuery } from "@tanstack/react-query";
import { fetchDoYouKnow } from "../api/homeApi";

export const useDoYouKnow = ({ storeUuid, token } = {}) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["do-you-know", { storeUuid }],
    queryFn: () => fetchDoYouKnow({ storeUuid, token }),
    enabled: !!storeUuid && !!token,
    staleTime: 5_000,
    refetchInterval: 30_000,
  });

  return {
    doYouKnowData: data ?? null,
    isDoYouKnowLoading: isLoading,
    doYouKnowError: error ?? null,
    isDoYouKnowConfigured: true,
  };
};
